export default "__VITE_ASSET__b500f889__"